import { createRouter, createWebHistory, START_LOCATION } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    // Preserve a deep-linked conversation through the login wall: pass it as
    // sso params so getLoginRedirectURL drops the user back into the thread
    // after sign-in (powers the oc.mkhb.my one-tap links). Falls back to a
    // plain login when the target isn't a conversation route.
    const accountMatch = to.path.match(/accounts\/(\d+)/);
    const conversationMatch = to.path.match(/conversations\/(\d+)/);
    const loginPath =
      accountMatch && conversationMatch
        ? `/app/login?sso_account_id=${accountMatch[1]}&sso_conversation_id=${conversationMatch[1]}`
        : '/app/login';
    window.location.assign(loginPath);
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      // Per-user default landing view (house toggle on the sidebar company
      // rows, saved as ui_settings.default_conversation_view): only the
      // FIRST navigation of a page load into the plain dashboard is
      // rerouted, so clicking "All Conversations" in-app still lands on the
      // global list. 'mk'/'s3' mirror COMPANY_TEAMS in sidebar/Sidebar.vue.
      if (to.name === 'home' && from === START_LOCATION) {
        const { default_conversation_view: defaultView } =
          store.getters.getUISettings || {};
        if (['mk', 's3'].includes(defaultView)) {
          return next({
            name: 'company_conversations',
            params: { accountId: to.params.accountId, company: defaultView },
          });
        }
      }
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
